import React from "react";
import { DeviceAdapter } from "@services/catalog/types";
import { ColDefWithTab } from "@pages/Assets/common/FilterColumn/context";
import { displayDateTime } from "@common/utils/localTime.utils";
import ListTypography from "@common/components/ListDetailViews/ListView/ListTypography";

export const columns: ColDefWithTab<DeviceAdapter>[] = [
  {
    key: "displayName",
    label: "Adapter Name",
    sortable: true,
    render: ({ displayName }) => (
      <ListTypography
        cellValue={displayName}
        sx={{ width: "100%", textAlign: "left" }}
      />
    ),
  },
  {
    key: "lastUpdatedTime",
    label: "Last Update",
    sortable: true,
    render: ({ lastUpdatedTime }) => (
      <ListTypography cellValue={displayDateTime(lastUpdatedTime)} />
    ),
  },
  {
    label: "Type",
    key: "releaseType",
    sortable: true,
    default: true,
    render: ({ releaseType }) => (
      <ListTypography cellValue={releaseType?.toUpperCase()} />
    ),
  },
  {
    key: "version",
    label: "Version",
    sortable: true,
    render: ({ version }) => <ListTypography cellValue={version} />,
  },
];
